import PageHero from "@/components/PageHero";
import PricingCards from "@/components/PricingCards";
import FAQ from "@/components/FAQ";
import CTA from "@/components/CTA";

const PRICING_FAQ = [
  { q: "Is Rxn3D a subscription?", a: "Yes. Lab plans are monthly subscription SaaS." },
  { q: "When does billing start?", a: "Billing starts after activation of your lab workspace. Some plans include a trial before charges begin." },
  { q: "Can I cancel anytime?", a: "Yes. Monthly plans can be cancelled at the end of the current billing cycle." },
  { q: "Do you offer refunds?", a: "Refunds are handled per our refund policy. Reach out via the contact form for edge cases." },
  { q: "Who are these plans for?", a: "The plans on this page are for dental laboratories. Offices and other roles may use different access models." },
  { q: "What do seats and slips mean?", a: "User and admin seats cover who can access the lab workspace. Slip capacity is the included case/slip volume for each billing cycle." },
  { q: "What payment methods do you accept?", a: "Card and bank transfer. Custom enterprise arrangements support invoicing." },
  { q: "Do prices include taxes?", a: "Applicable taxes may apply based on your billing region." },
];

export default function Pricing() {
  return (
    <>
      <PageHero
        chapter="§ 06"
        eyebrow="Lab pricing"
        title="Simple, transparent, no lock-in."
        description="Active lab plans from our catalog. Monthly subscriptions, cancel anytime. Software should earn your business every month, not lock you into a contract."
      />
      <PricingCards />
      <FAQ items={PRICING_FAQ} title="Pricing FAQ" />
      <CTA />
    </>
  );
}
